import { z } from 'zod'

const LocationQtySchema = z.object({
  location: z.string(),
  qty: z.number(),
})

const ItemSchema = z.object({
  id: z.number(),
  seq: z.number(),
  item: z.object({
    itemId: z.number(),
    isClaimItem: z.boolean(),
    lotNo: z.string().nullable(),
    lotDate: z.coerce.date().nullable(),
    mold: z.string().nullish(),
    unit: z.string(),
  }),
  refItemId: z.number().nullish(),
  qty: z.number(),
  fromLocations: z.array(LocationQtySchema),
  toLocations: z.array(LocationQtySchema),
})

export const Inv3010GetResultSchema = z.object({
  number: z.string(),
  date: z.coerce.date(),
  refNo: z.string().nullish(),
  refDate: z.coerce.date().nullish(),
  remark: z.string().nullish(),
  items: z.array(ItemSchema),
  status: z.number(),
})

export type Inv3010GetResultModel = z.input<typeof Inv3010GetResultSchema>
